import { getCurrentEnv } from '@/lib/utils/utils';

const isProduction = getCurrentEnv() === 'PROD';
const hasDebugContext = typeof window !== 'undefined' && window.localStorage.getItem('dd-debug') === 'on';
export const datadogConfig = {
  providerConfig: {
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID as string,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string,
    site: 'us5.datadoghq.com',
    env: isProduction ? 'prod' : 'qa'
  },
  evaluationContext: {
    kind: hasDebugContext ? 'dd-debug' : 'user',
    anonymous: true
  }
};
